import { RouteRecordRaw} from 'vue-router';

export const productRouteNames = {
    productList: 'products-list',
    productDetail: 'product-detail',
    productEdit: 'product-edit',
    productNew: 'product-new'
};

export const productRoutes: Array<RouteRecordRaw> = [
    {
        path: '/major-tom',
        //path: '/products/:id',
        name: productRouteNames.productDetail,
        component: () => import('@/views/product/ProductDetail.vue')
    }
];
